import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";

export default function CustomerSignature() {
  return (
    <Box p={4}>
      <Heading size="md" mb={4}>
        Mail İmza
      </Heading>
      <Text>
        Burada müşteri kendi mail imzasını görecek. (Önizleme + kopyalama +
        indirme seçenekleri buraya gelecek.)
      </Text>
    </Box>
  );
}
